import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, useRef, Suspense } from 'react';
import crashGameIcon from '../static/img/icon-btn/crash-game-icon.png';
import { openGameModal } from '../modal/modal_game';
import ModalLogin from '../modal/modal_login.js';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const LOAD_GAMES_BY_CATEGORY = ({ Game, category, category_name, onClose, AuthService, isLogged, setIsLoginModalOpen }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const modalBodyRef = useRef(null);
  const { t } = useTranslation();

  const user_id = AuthService.getCustom('user_id');


  const updateFavoriteGame = async (newGameId ) => {
    if (isLogged) {
        try {
          // Получаем инфу об игре
          const gameInfo = await Game.getGameInfo(newGameId);
          const gameType = gameInfo?.data?.category_slug || '';

          const user_id = await AuthService.getCustom('user_id');
          const lastGames = await Game.updateFavoriteGames(user_id, gameType, newGameId );
          
          // console.log("NUOVO GIOCO PREFERITO");

        } catch (error) {
            console.error('Failed to fetch game info or open game:', error);
        }
    } else if (!isLogged) {
        setIsLoginModalOpen(true);
        console.error(t('User_is_not_logged_in.'));
    }

    console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
};

  const fetchGames = async (currentPage) => {
    if (loading || !hasMore) return;
    try {
      setLoading(true);

      const response = await Game.getGameByCategory(category, 24, currentPage, user_id);
      // console.log(response);
      if (response?.status === "ok" || Array.isArray(response?.params?.games)) {
        const newGames = response?.params?.games || [];
        setGames((prevGames) => [...prevGames, ...newGames]);
        setHasMore(newGames.length > 0);
      } else {
        setHasMore(false);
      }

      // const response = await Game.getGameByCategory(category, 24, currentPage, user_id);

      // if (response?.status === true || Array.isArray(response?.data)) {
      //   const newGames = response.data?.data || response.data || [];
      //   setGames((prevGames) => [...prevGames, ...newGames]);
      //   setHasMore(newGames.length > 0);
      // } else {
      //   setHasMore(false);
      // }
    } catch (error) {
      console.error('Error fetching category games:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGames(page);
  }, [page]);

  const handleScroll = () => {
    if (!modalBodyRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = modalBodyRef.current;
    if (scrollHeight - scrollTop <= clientHeight + 50 && !loading && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const getCategoryIcon = (category) =>
    `${cmsUrl}static/img/icon-btn/${category}-icon.png`;
  

  return (
    <>
      <div
        className="modal fade provider-box-modal show"
        id="CategoryModal_single"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        style={{ display: 'block' }}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div
              className="modal-body"
              onScroll={handleScroll}
              ref={modalBodyRef}
              style={{ maxHeight: '100%', overflowY: 'auto' }}
            >
              <div className="Home_header">
              <a
                  className="HomeSection_header"
                  onClick={onClose}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start' }}
                >
                  <div className="HomeSection_icon">
                    <div className="arrow left"></div>
                    <img alt={category_name} src={category === 'crash-game' ? "/assets/img/icon-btn/crash-game-icon.png" : getCategoryIcon(category)} style={{filter:"invert(1)"}}/>
                  </div>
                  <div className="HomeSection_label" style={{ cursor: 'pointer' }}>{category_name}</div>
                </a>
              </div>

              <div className="body main-layout-item ColumnSection_list">
                <div className="Home_root">
                  <div className="Home_games">
                    <div className="HomeSectionCasinoGames_list">
                      {games.map((game, index) => (
                        <div className="HomeSectionCasinoGames_game" key={index} /* onClick={() => openGameModal(game.game_id)} */>
                          <div className="CasinoGameCard_root">
                            <div className="CasinoGamePreview_root" onClick={() => openGameModal(game.id)}>
                              <div className="CasinoGamePreview_gradient"></div>
                              <img
                                className="ResponsivePicture_img CasinoGamePreview_image"
                                src={game.thumbnail || ''}
                                alt={game.name}
                                loading="lazy"
                              />
                            </div>
                            <div className="CasinoGameCard_info CasinoGameCard_withProvider" >
                              <p className="CasinoGameCard_gameName" title={ game.name } onClick={() => openGameModal(game.id)}>{game.name}</p>
                              <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "85%"}} onClick={
                                  () => {
                                  if(isLogged){
                                      updateFavoriteGame(game.id);
                                      setGames(prev =>
                                      prev.map(g =>
                                          g.id === game.id
                                          ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                                          : g
                                      )
                                      );
                                  } else{
                                      setIsLoginModalOpen(true);
                                  }
                                  }  
                              }>
                                  <svg className="" viewBox='0 0 50 50'>
                                  <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                                      c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                                      C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                                  />
                                  </svg>

                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      {loading && (
                        <div className="content-loader-games">
                          {t('Loading games')}...
                          <div className="loader-games"></div>
                        </div>
                      )}
                      {!hasMore && <p>{t('No_more_games_to_load')}</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default LOAD_GAMES_BY_CATEGORY;
